import React from "react";
import { Routes, Route } from "react-router-dom";
import CurrencyRates from "./pages/currencyRates.tsx";
import Home from "./pages/home.tsx";
import Login from "./pages/login.tsx";
import AdminSearchRequest from "./pages/adminSearchRequest.tsx";
import AdminRequestList from "./pages/adminRequestList.tsx";
import NimaForms from "./pages/nimaForms.tsx";
import CurrencyList from "./pages/currencylist.tsx";
import ExpertCheckForms from "./pages/expertCheckForms.tsx";
import CountriesPercentage from "./pages/countriesPercentage.tsx";
import ExpertAddPoll from "./pages/expertAddPoll.tsx";
import ClientAnswerQuestion from "./pages/clientAnswerPoll.tsx";
import ClientPoll from "./pages/clientPoll.tsx";
import ShowFilledForms from "./pages/showFilledForms.tsx";
import ExpertCheckPoll from "./pages/expertCheckPoll.tsx";
import ShowWhoAnswersPoll from "./pages/showWhoAnswersPoll.tsx";
import jwtDecode from "jwt-decode";
import SanaForms from "./pages/sanaForms.tsx";
import AdminRequestHistory from "./pages/adminRequestHistory.tsx";
import CustomerDetails from "./pages/customerDetails.tsx";
import CoinPrices from "./pages/coinPrices.tsx";
import LevelsAndServices from "./pages/levelsAndServices.tsx";
import CostumerServicesList from "./pages/costumerServicesList.tsx";
import CostumerAssignedServices from "./pages/costumerAssignedServices.tsx";
import AdminCheckServices from "./pages/adminCheckServices.tsx";
import CustomerClubHint from "./pages/customerClubHint.tsx";
import Bonbast2 from "./pages/bonbast2.tsx";

function Routing() {
  const token = localStorage.getItem("token");

  let decode = {};
  if (token) {
    decode = jwtDecode(token);
  }
  return (
    <div>
      <Routes>
        <Route path="/RequestDetails/:requestId" element={<Home />} />
        <Route path="/bonbast" element={<Bonbast2 />} />
        <Route path="/login" element={<Login />} />
        <Route
          path="/searchRequest"
          element={
            decode.role === "Admin" || decode.role === "Expert" ? (
              <AdminSearchRequest />
            ) : (
              <CurrencyRates />
            )
          }
        />
        <Route
          path="/requestList"
          element={
            decode.role === "Admin" ? <AdminRequestList /> : <CurrencyRates />
          }
        />
        <Route
          path="/expertServices"
          element={
            decode.role === "Admin" ? <LevelsAndServices /> : <CurrencyRates />
          }
        />
        <Route
          path="/expertCheckForms"
          element={
            decode.role === "Admin" || decode.role === "Expert" ? (
              <ExpertCheckForms />
            ) : (
              <CurrencyRates />
            )
          }
        />
        <Route
          path="/adminCheckServices"
          element={
            decode.role === "Admin" || decode.role === "Expert" ? (
              <AdminCheckServices />
            ) : (
              <CurrencyRates />
            )
          }
        />
        <Route path="/adminRequestHistory" element={<AdminRequestHistory />} />
        <Route
          path="/expertAddPoll"
          element={
            decode.role === "Admin" ? <ExpertAddPoll /> : <CurrencyRates />
          }
        />
        <Route path="/nimaForms" element={<NimaForms />} />
        <Route path="/sanaForms" element={<SanaForms />} />
        <Route path="/clientPoll/:pollformId" element={<ClientPoll />} />
        <Route
          path="/costumerServicesList"
          element={<CostumerServicesList />}
        />
        <Route
          path="/costumerAssignedServices"
          element={<CostumerAssignedServices />}
        />
        <Route
          path="/showFilledForms"
          element={
            decode.role === "Admin" ? <ShowFilledForms /> : <CurrencyRates />
          }
        />
        <Route path="/listOfQuestions" element={<ClientAnswerQuestion />} />
        <Route path="/customerDetails" element={<CustomerDetails />} />
        <Route
          path="/expertCheckPoll/:pollformId"
          element={
            decode.role === "Admin" ? <ExpertCheckPoll /> : <CurrencyRates />
          }
        />
        <Route
          path="/showWhoAnswersPoll/:pollformId"
          element={
            decode.role === "Admin" ? <ShowWhoAnswersPoll /> : <CurrencyRates />
          }
        />
        <Route path="/currencyList" element={<CurrencyList />} />
        <Route path="/CoinPrices" element={<CoinPrices />} />
        <Route path="/customerclub" element={<CustomerClubHint />} />
        <Route path="/countriesPercentage" element={<CountriesPercentage />} />
        <Route path="/CurrencyRates" element={<CurrencyRates />} />
        <Route path="/" element={<CurrencyRates />} />
        <Route path="*" element={<CurrencyRates />} />
      </Routes>
    </div>
  );
}

export default Routing;
